import type {ReactNode} from 'react';
import {AlertTriangle} from 'lucide-react';
import {POSTHOG_UNMASK_CLASS} from '@common-web/lib/analytics';

export function WarningBanner({children}: {children: ReactNode}) {
  return (
    <div
      role='alert'
      className={`flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800 ${POSTHOG_UNMASK_CLASS}`}
    >
      <AlertTriangle className='mt-0.5 h-5 w-5 shrink-0 text-amber-500' />
      <p>{children}</p>
    </div>
  );
}
